import React, { Fragment } from 'react'
import SubscriptionDetail from '../../Components/Subscription'
import TopBanner from '../../Components/Main/TopBanner'

const Subscription = () => {
    return (
        <Fragment >
            <TopBanner title={"Subscription"} />
            <SubscriptionDetail />
        </Fragment>
    )
}

export default Subscription